var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import SidebarItem from "../SidebarItem/SidebarItem";
// styles
import "./sidebarContent.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-sidebarContent",
};
const SidebarContent = (_a) => {
    var { itemsOnTop, itemsOnBottom, isOpen, position, className } = _a, rest = __rest(_a, ["itemsOnTop", "itemsOnBottom", "isOpen", "position", "className"]);
    const classList = classNames("tecma-sidebarContent", { isOpen }, className);
    const navRef = useRef(null);
    const [parentRef, setParentRef] = useState(undefined);
    useEffect(() => {
        if (navRef.current)
            setParentRef(navRef.current);
    }, []);
    return (_jsxs("nav", Object.assign({ className: classList }, rest, { ref: navRef, children: [_jsx("ul", { children: itemsOnTop.map((item) => (_jsx(SidebarItem, { onClick: item.onClick, iconName: item.icon, label: item.label, position: position, isOpen: isOpen, parentRef: parentRef === null || parentRef === void 0 ? void 0 : parentRef.parentElement }, item.label))) }), _jsx("ul", { children: itemsOnBottom &&
                    itemsOnBottom.length > 0 &&
                    itemsOnBottom.map((item) => (_jsx(SidebarItem, { onClick: item.onClick, iconName: item.icon, label: item.label, position: position, isOpen: isOpen, parentRef: parentRef === null || parentRef === void 0 ? void 0 : parentRef.parentElement }, item.label))) })] })));
};
SidebarContent.defaultProps = defaultProps;
export default React.memo(SidebarContent);
